import { render, staticRenderFns } from "./divisionrulemanagement.vue?vue&type=template&id=e066067a&scoped=true"
import script from "./divisionrulemanagement.vue?vue&type=script&lang=js"
export * from "./divisionrulemanagement.vue?vue&type=script&lang=js"
import style0 from "./divisionrulemanagement.vue?vue&type=style&index=0&id=e066067a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e066067a",
  null
  
)

export default component.exports